var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBowlFill = function SvgIconBowlFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.475 16.768-.02-.042-1.706-3.521a.459.459 0 0 1-.024-.05l-.4-.826.002-.001-.233-.483C5.412 12.812 8.258 13.5 12 13.5c3.742 0 6.588-.688 9.907-1.656l-.622 1.286a.963.963 0 0 1-.05.102l-1.712 3.536C18.423 18.76 16.292 20 13.96 20h-3.921c-2.333 0-4.465-1.239-5.564-3.232Zm18.02-6.14.314-.651.024-.053c.379-.94.092-2.088-.642-2.608l-4.124-3.023A1.572 1.572 0 0 0 17.159 4H6.84a1.58 1.58 0 0 0-.92.302l-4.1 3.006c-.746.528-1.033 1.677-.654 2.616l.34.705C5.199 11.725 8.088 12.5 12 12.5c3.914 0 6.803-.775 10.494-1.871l.001-.001Z"
  })));
};
export default SvgIconBowlFill;